var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "message-box dialog-mask" }, [
    _c("div", { staticClass: "dialog-box" }, [
      _c(
        "button",
        {
          staticClass: "close-button",
          attrs: {
            type: "button",
            disabled: _vm.submitting,
            "aria-label": _vm.notReceiveLabel,
          },
          on: { click: _vm.onNotReceive },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
      _c("div", { staticClass: "dialog-header" }, [
        _c("img", {
          attrs: {
            src: require("@/assets/img/email-magazine/cat-header.png"),
            alt: _vm.titleLabel,
          },
        }),
      ]),
      _c("div", { staticClass: "dialog-body" }, [
        _c("h1", [
          _vm._v(
            _vm._s(_vm.$t("myPage.emailNotification.confirmDialog.title"))
          ),
        ]),
        _c("p", { staticClass: "description" }, [
          _vm._v(
            _vm._s(_vm.$t("myPage.emailNotification.confirmDialog.description"))
          ),
        ]),
      ]),
      _c("footer", [
        _c(
          "button",
          {
            staticClass: "button receive",
            attrs: { disabled: _vm.submitting },
            on: { click: _vm.onReceive },
          },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("myPage.emailNotification.confirmDialog.receive")
                ) +
                " "
            ),
          ]
        ),
        _c(
          "button",
          {
            staticClass: "button not-receive",
            attrs: { disabled: _vm.submitting },
            on: { click: _vm.onNotReceive },
          },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("myPage.emailNotification.confirmDialog.notReceive")
                ) +
                " "
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }